export default __webpack_public_path__ + "static/media/decreament.f5564cd8.svg";